import clsx from "clsx";
import { useRouter } from "next/compat/router";
import type { PropsWithChildren } from "react";

const Body = ({
	children,
	className,
}: PropsWithChildren<{ className?: string }>) => {
	const { pathname } = useRouter() || {};

	return (
		<div key={pathname} className={clsx(`flex-1`, className)}>
			{children}
		</div>
	);
};

export default Body;
